module.exports = __webpack_public_path__ + "static/img/img1.6071e68.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img1.png
// module id = GmyW
// module chunks = 23